import { Component, HostListener, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';

@Component({
  selector: 'pages-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
  animations: [
    trigger('scrollAnimation', [
      state('show', style({
        opacity: 1,
        transform: "translateX(0)"
      })),
      state('hide', style({
        opacity: 0,
        transform: "translateX(-150%)"
      })),
      transition('show => hide', animate('1500ms ease-out')),
      transition('hide => show', animate('1500ms ease-in'))
    ]),
    trigger('boxState', [
      state('in', style({
        opacity: 0.5,
        transform: 'scale(1.5)'
      })),
      state('out',   style({
        opacity: 1,
        transform: 'scale(1)'
      })),
      state('boom',   style({
        opacity: 0,
        transform: 'scale(10)'
      })),
      transition('* => boom', animate('300ms')),
      transition('* => in', animate('300ms')),
      transition('in => out', animate('300ms')),
      transition('out => in', animate('300ms'))
    ])
  ]
})
export class PagesAboutComponent {

  state = 'hide'
  mouse_state = 'out'

  constructor(public el: ElementRef) { }

  @HostListener('mouseover', ['$event'])
  @HostListener('mouseleave', ['$event'])
  onHover(event: MouseEvent) {
    const direction = event.type === 'mouseover' ? 'in' : 'out';
    if(direction === 'in'){
      this.mouse_state = 'in'
    }else {
      this.mouse_state = 'out'
    }
  }

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    const componentPosition = this.el.nativeElement.offsetTop
    const scrollPosition = window.pageYOffset
    const transitionPosition = componentPosition + 250;


    if (scrollPosition <= transitionPosition) {
      this.state = 'show'
    } else {
      this.state = 'hide'
    }

  }
 }



// WEBPACK FOOTER //
// ./src/app/pages/about/about.component.ts